import { Link } from "react-router-dom";
import { ChevronRight } from "./icons";
import type { BlogPost } from "../data/blogPosts";
import { useLanguage } from "../context/LanguageContext";

export default function BlogPostCard({ post }: { post: BlogPost }) {
  const { t } = useLanguage();
  return (
    <Link to={`/blog/${post.slug}`} className="group flex flex-col">
      <div className="aspect-[4/3] overflow-hidden bg-steel-100">
        <img
          src={post.image}
          alt={post.title}
          draggable={false}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 ease-engineered group-hover:scale-105"
        />
      </div>
      <p className="mt-4 text-xs font-semibold uppercase tracking-wide2 text-accent">{post.category}</p>
      <h3 className="mt-2 font-sans text-lg font-semibold tracking-tight leading-snug text-ink">{post.title}</h3>
      <span className="mt-3 flex items-center gap-1 text-sm font-semibold text-ink transition-colors duration-200 ease-engineered group-hover:text-accent">
        {t("blogReadMore")}
        <ChevronRight size={15} />
      </span>
    </Link>
  );
}
